import theme from '@styles/theme';
export default {
  inputDesriptionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: '4px',
    mr: '16px',
    pl: '16px',
    color: theme.rawColors.darkGrey500
  }
};